// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"baa0b4c7","291":"0ee390f0","452":"14e3272c","477":"c2e22a1f","489":"fca81801","495":"45db2caf","548":"630515e4","605":"b765b347","606":"3c9d7cfb","696":"5dc55dbc","849":"cefb7dda","971":"72f45d26"}[chunkId] + ".chunk.js";
};